import { useState } from "react";
import DashboardElements from "./DashboardElements";
import LeadsChart from "./LeadsChart";

const LeadsChartContainer = () => {
    const [timeRange, setTimeRange] = useState("7 Days");
    const [totalLeads, setTotalLeads] = useState(0);

    const btnStyle = {
        display: 'flex',
        padding: '8px 16px',
        marginRight: '9px',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '10px',
        flexShrink: 0,
        borderRadius: '5px',
        background: '#FFF',
        cursor: 'pointer',
        border: '1px solid transparent',
    };

    const activeBtnStyle = {
        display: 'flex',
        padding: '8px 16px',
        marginRight: '9px',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '10px',
        flexShrink: 0,
        borderRadius: '5px',
        background: '#FFF',
        border: '1px solid #A1A1AA',
        cursor: 'pointer',
    };

    const [btn7Style, setBtn7Style] = useState(activeBtnStyle);
    const [btn1Style, setBtn1Style] = useState(btnStyle);
    const [btn6Style, setBtn6Style] = useState(btnStyle);

    const handleBtn7Style = () => {
        setBtn7Style(activeBtnStyle);
        setTimeRange("7 Days");
        setBtn1Style(btnStyle);
        setBtn6Style(btnStyle);
    }

    const handleBtn1Style = () => {
        setBtn1Style(activeBtnStyle);
        setTimeRange("1 Month");
        setBtn7Style(btnStyle);
        setBtn6Style(btnStyle);
    }

    const handleBtn6Style = () => {
        setBtn6Style(activeBtnStyle);
        setTimeRange("6 Months");
        setBtn7Style(btnStyle);
        setBtn1Style(btnStyle);
    }

    return (
        <div>
            <DashboardElements.ChartContainer>
                <div style={{ display: 'flex' }}>
                    <DashboardElements.ChartHeader>
                        Leads over time
                    </DashboardElements.ChartHeader>
                    <DashboardElements.MonthButtonsContainer>
                        <button style={btn7Style} onClick={handleBtn7Style}>
                            7 Days
                        </button>
                        <button style={btn1Style} onClick={handleBtn1Style}>
                            1 Month
                        </button>
                        <button style={btn6Style} onClick={handleBtn6Style}>
                            6 Months
                        </button>
                    </DashboardElements.MonthButtonsContainer>
                </div>
                <LeadsChart className="leads-chart" timeRange={timeRange} onDataUpdate={setTotalLeads} />
            </DashboardElements.ChartContainer>
        </div>
    );
}

export default LeadsChartContainer;
